import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Bell, X, Share } from "lucide-react";
import { pushSupported, enablePush, isIOS, isStandalone, pushPermission } from "@/push";

// Banner che invita ogni utente ad attivare le notifiche push subito dopo il login.
// - Browser/PWA supportati con permesso "default" -> mostra "Attiva notifiche".
// - iPhone/iPad da Safari (non installato) -> istruzioni "Aggiungi a Home".
export default function PushPrompt() {
  const [mode, setMode] = useState(null); // "enable" | "ios-install" | null
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("push_prompt_dismissed") === "1") return;
    if (pushSupported()) {
      if (pushPermission() === "default") setMode("enable");
    } else if (isIOS() && !isStandalone()) {
      setMode("ios-install");
    }
  }, []);

  const dismiss = () => {
    sessionStorage.setItem("push_prompt_dismissed", "1");
    setMode(null);
  };

  const activate = async () => {
    setBusy(true);
    try {
      await enablePush();
      toast.success("Notifiche attivate! ✅");
      setMode(null);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };

  if (!mode) return null;

  return (
    <div data-testid="push-prompt" className="mx-auto max-w-3xl px-4 pt-4">
      <div className="relative rounded-xl border border-[#F59E0B]/40 bg-[#F59E0B]/10 p-4 pr-9">
        <button
          data-testid="push-prompt-dismiss"
          onClick={dismiss}
          className="absolute top-2.5 right-2.5 text-[#94A3B8] hover:text-white transition-colors"
          aria-label="Chiudi"
        >
          <X size={16} />
        </button>
        {mode === "enable" ? (
          <div className="flex items-start gap-3">
            <div className="mt-0.5 shrink-0 rounded-lg bg-[#F59E0B]/20 p-2">
              <Bell size={18} className="text-[#F59E0B]" />
            </div>
            <div className="min-w-0">
              <div className="font-extrabold text-[#F1F5F9]">Attiva le notifiche</div>
              <div className="text-sm text-[#CBD5E1] mt-0.5">
                Ricevi gli avvisi di scadenze, risultati e vincite direttamente sul telefono.
              </div>
              <button
                data-testid="push-prompt-enable"
                onClick={activate}
                disabled={busy}
                className="mt-3 bg-[#F59E0B] text-[#1A1000] font-bold text-sm rounded-md px-4 py-2 flex items-center gap-2 disabled:opacity-50 active:scale-95 transition-transform"
              >
                <Bell size={15} /> {busy ? "Attivazione…" : "Attiva notifiche"}
              </button>
            </div>
          </div>
        ) : (
          <div className="flex items-start gap-3">
            <div className="mt-0.5 shrink-0 rounded-lg bg-[#F59E0B]/20 p-2">
              <Share size={18} className="text-[#F59E0B]" />
            </div>
            <div className="min-w-0">
              <div className="font-extrabold text-[#F1F5F9]">Vuoi le notifiche su iPhone?</div>
              <div className="text-sm text-[#CBD5E1] mt-0.5">
                Installa prima l'app: tocca <b>Condividi</b> in basso, poi{" "}
                <b>"Aggiungi alla schermata Home"</b>. Apri RinoMagic da quell'icona e potrai attivare le notifiche.
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
